<template>
  <div>
    <generic-modal
      v-if="Object.keys(showProductCardInModalFor).length > 0"
      @close.stop="closeProductCardModal($event, '')"
      :width="productCardModalDim.width"
      :modalClass="productCardModalDim.modalClass"
      :animationStyle="productCardModalDim.animationStyle"
      :height="productCardModalDim.height"
      :overflowNotNeeded="0"
      :genericModalSource="'customizationModal'"
    >
      <template v-slot:header>
        <div class="slide-handle"></div>
        <span class="d-flex justify-content-right mb10">
          <i
            @click.stop="closeProductCardModal($event, 'cross')"
            class="hkfi-close cm-close"
          ></i>
        </span>
      </template>
      <template v-slot:body>
        <hongs-product-card
          :key="'product-card-modal'"
          :data-item="showProductCardInModalFor"
          :data-cardRounded="productCardProps.cardRounded"
          :data-smallCards="productCardProps.smallCards"
          :data-hideImage="productCardProps.hideImage"
          :isInModal="productCardProps.isInModal"
          :showFullInfo="true"
        ></hongs-product-card>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import HongsProductCard from "./HongsProductCard.vue";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";

export default {
  name: "ProductCardModal",
  components: {
    GenericModal,
    HongsProductCard,
  },
  // props: ['dataResults'],
  data() {
    return {
      productCardModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "card-modal-wrap full-screen-popup lg-screen-centered",
      },
      productCardProps: {
        cardRounded: true,
        smallCards: false,
        hideImage: false,
        isInModal: true,
      },
    };
  },
  mounted() {},
  methods: {
    closeProductCardModal(e, source) {
      e.stopPropagation();
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_PRODUCT_CARD_IN_MODAL_FOR,
        {}
      );
      if (!this.$store.state.ProductItems.showSearchModal) {
        document.body.classList.remove("body-stop-scroll-mobile");
      }
    },
  },
  computed: {
    showProductCardInModalFor() {
      return this.$store.state.ProductItems.showProductCardInModalFor;
    },
  },
};
</script>
